webpackJsonp([57],{

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvailableJob_vue__ = __webpack_require__(725);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_490c4953_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvailableJob_vue__ = __webpack_require__(891);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvailableJob_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_490c4953_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvailableJob_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(57);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export syncApi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



var _this = this;




var _guardCallback = function _guardCallback(arg) {
  if (typeof arg === "function") {
    arg();
  }
};

var _onError = function _onError(error) {
  if (error.response) {
    if (error.response.data.errors) {
      if (Array.isArray(error.response.data.errors)) {
        for (var index = 0; index < error.response.data.errors.length; index++) {
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[index], {
            title: "Error"
          });
        }
      } else {
        for (var prop in error.response.data.errors) {
          if (!error.response.data.errors.hasOwnProperty(prop)) {
            continue;
          }
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[prop][0], {
            title: "Error"
          });
        }
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Request failed with status code " + error.response.status, { title: "Error" });
    }
  } else if (error.request) {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something wrong with request messages.", {
      title: "Error"
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something went wrong, please try again later.", {
      title: "Error"
    });
  }

  return {
    isSuccess: false
  };
};

var syncApi = {
  get: function get(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  post: function post(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  put: function put(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  delete: function _delete(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  getWithOptions: function getWithOptions(url, option, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  postWithOptions: function postWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  putWithOptions: function putWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  }
};

var asyncApi = {
  get: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _guardCallback(onBeginCallback);
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", _onError(_context.t0));

            case 11:
              _context.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8, 11, 14]]);
    }));

    return function get(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),
  post: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              _guardCallback(onBeginCallback);
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return", onErrorCallback(_context2.t0.response.data));

            case 12:
              return _context2.abrupt("return", _onError(_context2.t0));

            case 13:
              _context2.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context2.finish(13);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[0, 8, 13, 16]]);
    }));

    return function post(_x4, _x5, _x6, _x7, _x8) {
      return _ref2.apply(this, arguments);
    };
  }(),
  put: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              _guardCallback(onBeginCallback);
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context3.next = 12;
                break;
              }

              return _context3.abrupt("return", onErrorCallback(_context3.t0.response.data));

            case 12:
              return _context3.abrupt("return", _onError(_context3.t0));

            case 13:
              _context3.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context3.finish(13);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[0, 8, 13, 16]]);
    }));

    return function put(_x9, _x10, _x11, _x12, _x13) {
      return _ref3.apply(this, arguments);
    };
  }(),
  delete: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              _guardCallback(onBeginCallback);
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", _onError(_context4.t0));

            case 11:
              _context4.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context4.finish(11);

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this, [[0, 8, 11, 14]]);
    }));

    return function _delete(_x14, _x15, _x16) {
      return _ref4.apply(this, arguments);
    };
  }(),
  getWithOptions: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(url, option, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              _guardCallback(onBeginCallback);
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
              return _context5.abrupt("return", _onError(_context5.t0));

            case 11:
              _context5.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context5.finish(11);

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this, [[0, 8, 11, 14]]);
    }));

    return function getWithOptions(_x17, _x18, _x19, _x20) {
      return _ref5.apply(this, arguments);
    };
  }(),
  postWithOptions: function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;

              _guardCallback(onBeginCallback);
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return", _onError(_context6.t0));

            case 11:
              _context6.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context6.finish(11);

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this, [[0, 8, 11, 14]]);
    }));

    return function postWithOptions(_x21, _x22, _x23, _x24, _x25) {
      return _ref6.apply(this, arguments);
    };
  }(),
  putWithOptions: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;

              _guardCallback(onBeginCallback);
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option);

            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              return _context7.abrupt("return", _onError(_context7.t0));

            case 11:
              _context7.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context7.finish(11);

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this, [[0, 8, 11, 14]]);
    }));

    return function putWithOptions(_x26, _x27, _x28, _x29, _x30) {
      return _ref7.apply(this, arguments);
    };
  }()
};



/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["id", "header", "content", "closeIcon", "cancelLabel", "submitLabel", "color", "icon", "subContent", "modalSize"],
  computed: {
    hasCloseIcon: function hasCloseIcon() {
      return this.closeIcon && this.closeIcon === true ? true : false;
    },
    hasCancel: function hasCancel() {
      return this.cancelLabel && this.cancelLabel !== "";
    },
    hasSubmit: function hasSubmit() {
      return this.submitLabel && this.submitLabel !== "";
    },
    getId: function getId() {
      return this.id && this.id !== "" ? this.id : "confirmmodal";
    },
    getColor: function getColor() {
      return this.color && this.color !== "" ? this.color : "confirm-icon";
    },
    getIcon: function getIcon() {
      return this.icon && this.icon !== "" ? this.icon : "ic-check";
    }
  },
  methods: {
    closeModal: function closeModal() {
      $("#" + this.getId).modal("hide");
    },
    cancel: function cancel() {
      this.$emit("onCancel");
    },
    submit: function submit() {
      $("#" + this.getId).modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmModal_vue__ = __webpack_require__(501);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af674af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmModal_vue__ = __webpack_require__(518);
function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6af674af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af674af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(517);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("5636d7fe", content, true, {});

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".note-content[data-v-6af674af]{font-size:13px;color:#999}.modal-header-confirm[data-v-6af674af]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:15px}", "", {"version":3,"sources":["/app/src/components/shared/ConfirmModal.vue"],"names":[],"mappings":"AACA,+BACE,eAAgB,AAChB,UAAY,CACb,AACD,uCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,YAAc,CACf","file":"ConfirmModal.vue","sourcesContent":["\n.note-content[data-v-6af674af] {\n  font-size: 13px;\n  color: #999;\n}\n.modal-header-confirm[data-v-6af674af] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding: 15px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":_vm.getId}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalSize === 'modal-sm' ? 'modal-sm' : 'modal-xs'},[_c('div',{staticClass:"modal-content"},[(_vm.hasCloseIcon)?_c('div',{staticClass:"modal-header-confirm"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ic-close"})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[(_vm.icon === 'ic-warning')?[_c('svg',{staticClass:"warning-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 20 20"}},[_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M8.686 2.852L2.127 14.777A1.5 1.5 0 0 0 3.441 17H16.56a1.5 1.5 0 0 0 1.314-2.223L11.314 2.852a1.5 1.5 0 0 0-2.628 0zM10 6.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75zm.75 7a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0z","fill":"currentColor"}})])])]:[_c('div',{class:_vm.getColor},[_c('i',{class:_vm.getIcon})])],_vm._v(" "),_c('header',[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),(_vm.subContent)?[_c('div',{staticClass:"note-content",domProps:{"innerHTML":_vm._s(_vm.subContent)}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(_vm.hasCancel)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.cancel}},[_vm._v("\n                  "+_vm._s(_vm.cancelLabel)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.hasSubmit)?_c('button',{staticClass:"btn btn-primary text-cap",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  "+_vm._s(_vm.submitLabel)+"\n                ")]):_vm._e()])],2)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_apiService__ = __webpack_require__(500);



var _this = this;



var _baseEndpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/job";

/* harmony default export */ __webpack_exports__["a"] = ({
  search: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(filter, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/available" + filter, onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function search(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),
  getSubscribers: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(reservationId, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/subscriber/" + reservationId, onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function getSubscribers(_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }(),
  getJobDetails: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(reservationId, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/" + reservationId, onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function getJobDetails(_x7, _x8, _x9) {
      return _ref3.apply(this, arguments);
    };
  }(),
  getListSubscriberProvider: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(reservationId, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/" + reservationId + "/subscriber/providers", onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function getListSubscriberProvider(_x10, _x11, _x12) {
      return _ref4.apply(this, arguments);
    };
  }(),
  dispatchJob: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].post(_baseEndpoint + "/accept", payload, onBeginCallback, onFinallyCallback, onErrorCallback));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function dispatchJob(_x13, _x14, _x15, _x16) {
      return _ref5.apply(this, arguments);
    };
  }(),
  reassignPreferredProvider: function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(reservationId, payload, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].put(_baseEndpoint + "/" + reservationId + "/preffered-provider/reassign", payload, onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this);
    }));

    return function reassignPreferredProvider(_x17, _x18, _x19, _x20) {
      return _ref6.apply(this, arguments);
    };
  }(),
  reassignProvider: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(reservationId, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].put(_baseEndpoint + "/" + reservationId + "/provider/reassign", payload, onBeginCallback, onFinallyCallback, onErrorCallback));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this);
    }));

    return function reassignProvider(_x21, _x22, _x23, _x24, _x25) {
      return _ref7.apply(this, arguments);
    };
  }()
});

/***/ }),

/***/ 725:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_job_availableJobService__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_ConfirmModal__ = __webpack_require__(509);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    confirmModal: __WEBPACK_IMPORTED_MODULE_5__components_shared_ConfirmModal__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: false,
      msg: "Please wait",
      period: "all",
      jobBrowserDateRange: null,
      formatter: null,
      timer: null,
      moneyFormat: {},
      selectedProvider: {
        reservationId: null,
        providerId: null,
        providerName: null,
        overrideTimingBlock: false
      },
      selectedJob: {
        reservationId: null,
        subscribers: {}
      },
      allPermissions: [],
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        items: []
      },
      provider: false,
      userType: "Unspecified"
    };
  },

  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToPickup: function isAllowToPickup() {
      return this.allPermissions.includes("Pickup");
    },
    time: function time() {
      var date = new Date();
      switch (this.period) {
        case "tomorrow":
          date.setDate(date.getDate() + 1);
          break;
        case "next":
          date.setDate(date.getDate() + 2);
          break;
      }
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format("dddd, MMMM DD yyyy");
    },
    recordInfo: function recordInfo() {
      return this.table.totalRecords > 1 ? this.table.totalRecords + " Records" : this.table.totalRecords + " Record";
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, profile, checkRoles, permissions;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _context.next = 3;
              return _this.$store.dispatch("setting/getAllPublic");

            case 3:
              publicSettings = _context.sent;

              _this.table.pageSize = _this.$helper.extractSetting(publicSettings, "PageSize", 25);

              _context.next = 7;
              return _this.$store.dispatch("user/getProfile");

            case 7:
              profile = _context.sent;

              _this.userType = profile.userType;

              checkRoles = profile.roles.find(function (val) {
                return val.toLowerCase() === "provider";
              });

              if (checkRoles) _this.provider = true;else _this.provider = false;

              permissions = profile.services[_this.$route.name];


              if (permissions) {
                _this.allPermissions = permissions;
              }

              if (!_this.isAllowToRead) {
                _context.next = 17;
                break;
              }

              _context.next = 16;
              return _this.search();

            case 16:

              if (_this.moneyFormat) {
                _this.formatter = new Intl.NumberFormat(_this.moneyFormat.cultureCode, {
                  style: "currency",
                  currency: _this.moneyFormat.currencyCode,
                  currencyDisplay: "code",
                  minimumFractionDigits: _this.moneyFormat.numberOfDecimal
                });
              }

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  updated: function updated() {
    this.$helper.collapseMenu("job");
    this.$helper.setNavigationClass("available-job-browser-link");
    $("#jobBrowserDateRange-input").addClass("borderless-jobBrowserDateRange");
  },

  methods: {
    startLoader: function startLoader() {
      this.isLoading = true;
    },
    stopLoader: function stopLoader() {
      this.isLoading = false;
    },
    showPicker: function showPicker() {
      $(".tabs-inquiry").removeClass("sticky");
    },
    hidePicker: function hidePicker() {
      $(".tabs-inquiry").addClass("sticky");
    },
    convertPeriod: function convertPeriod() {
      var result = "";
      var date = new Date();
      switch (this.period.toLowerCase()) {
        case "all":
          this.jobBrowserDateRange = null;
          result = "all";
          break;
        case "today":
          this.jobBrowserDateRange = null;
          result = "today_" + date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
          break;
        case "tomorrow":
          this.jobBrowserDateRange = null;
          date.setDate(date.getDate() + 1);
          result = "tomorrow_" + date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
          break;
        case "next":
          this.jobBrowserDateRange = null;
          date.setDate(date.getDate() + 2);
          result = "next_" + date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
          break;
        case "range":
          result = "range_" + this.jobBrowserDateRange.start + "_" + this.jobBrowserDateRange.end;
          break;
      }
      return result;
    },
    isAirportTransfer: function isAirportTransfer(serviceType) {
      return serviceType.toLowerCase() === "airporttransfer";
    },
    openDispatchDialog: function openDispatchDialog(providerId, providerName) {
      this.selectedProvider.providerId = providerId;
      this.selectedProvider.providerName = providerName;
      $("#DispatchConfirmation").modal({ backdrop: "static", keyboard: false });
    },
    clearPayload: function clearPayload() {
      this.selectedProvider = {
        reservationId: null,
        providerId: null,
        providerName: null,
        overrideTimingBlock: false
      };
      this.selectedJob = { reservationId: null, subscribers: {} };
    },
    changePeriods: function changePeriods(period) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.period = period;
                _context2.next = 3;
                return _this2.search();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onChangePageSize: function onChangePageSize() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.table.pageNumber = 1;
                _context3.next = 3;
                return _this3.search();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    onKeyupKeyword: function onKeyupKeyword() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                self = _this4;

                if (self.timer) {
                  clearTimeout(self.timer);
                  self.timer = null;
                }
                self.timer = setTimeout(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(_) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            self.table.pageNumber = 1;
                            _context4.next = 3;
                            return self.search();

                          case 3:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this4);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }(), 500);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    onNavigateCallback: function onNavigateCallback(pageNumber) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this5.table.pageNumber = pageNumber;
                _context6.next = 3;
                return _this5.search();

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    search: function search() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var filter, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                filter = "?page=" + _this6.table.pageNumber + "&size=" + _this6.table.pageSize + "&data=" + _this6.convertPeriod();


                if (_this6.table.keyword !== null && _this6.table.keyword !== "") {
                  filter += "&search=" + _this6.table.keyword;
                }

                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_job_availableJobService__["a" /* default */].search(filter, _this6.startLoader, _this6.stopLoader);

              case 4:
                response = _context7.sent;


                if (response.isSuccess) {
                  _this6.moneyFormat = response.data.moneyFormat;
                  _this6.table.items = response.data.items;
                  _this6.table.totalPages = response.totalPages;
                  _this6.table.totalRecords = response.totalRecords;
                }

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    },
    searchRange: function searchRange() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(!_this7.jobBrowserDateRange.start || _this7.jobBrowserDateRange.start === "" || !_this7.jobBrowserDateRange.end || _this7.jobBrowserDateRange.end === "")) {
                  _context8.next = 3;
                  break;
                }

                alert("Please select a date range.");
                return _context8.abrupt("return");

              case 3:
                _this7.hidePicker();
                _context8.next = 6;
                return _this7.changePeriods("range");

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this7);
      }))();
    },
    pickupJob: function pickupJob(job) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(job.providers.length > 1)) {
                  _context9.next = 7;
                  break;
                }

                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__services_job_availableJobService__["a" /* default */].getSubscribers(job.reservationId, _this8.startLoader, _this8.stopLoader);

              case 3:
                response = _context9.sent;


                if (response.isSuccess) {
                  _this8.selectedProvider.reservationId = job.reservationId;
                  _this8.selectedJob = {
                    reservationId: job.reservationId,
                    subscribers: response.data
                  };

                  $(_this8.$refs.modal_subscribers).modal({
                    backdrop: "static",
                    keyboard: false
                  });
                }
                _context9.next = 10;
                break;

              case 7:
                _this8.selectedProvider = {
                  reservationId: job.reservationId,
                  providerId: job.providers[0],
                  overrideTimingBlock: false
                };
                _context9.next = 10;
                return _this8.dispatchJob();

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this8);
      }))();
    },
    dispatchJob: function dispatchJob() {
      var _this9 = this;

      var fromModal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var overrideTimingBlock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var payload, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this9.selectedProvider, { overrideTimingBlock: overrideTimingBlock });
                _context10.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__services_job_availableJobService__["a" /* default */].dispatchJob(payload, _this9.startLoader, _this9.stopLoader, _this9.dispatchOverrideModal);

              case 3:
                response = _context10.sent;


                if (response && response.isSuccess) {
                  _this9.clearPayload();

                  _this9.search().then(function () {
                    if (fromModal) {
                      $(_this9.$refs.modal_subscribers).modal("hide");
                    }
                    _this9.$notification.success("Successfully dispatched.", {
                      title: "Success"
                    });
                  });
                }

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this9);
      }))();
    },
    dispatchOverrideModal: function dispatchOverrideModal(data) {
      if (this.userType === "TenantUser" && data.errors[0].includes("JTB001|")) {
        $("#OverrideConfirmation").modal({
          backdrop: "static",
          keyboard: false
        });
      }
    },
    cancelConfirmation: function cancelConfirmation() {
      setTimeout(function () {
        $("body").addClass("modal-open");
      }, 500);
    }
  }
});

/***/ }),

/***/ 891:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section-header-info middle-content"},[_c('div',{staticClass:"container big-container"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('h3',[_vm._v("Open Jobs")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"data-row --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.time))])]),_vm._v(" "),_c('div',{staticClass:"form-group mt-20"},[_c('div',{staticClass:"btn-group btn-group-toggle mb-25",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.period === 'all' },attrs:{"type":"button"},on:{"click":function($event){return _vm.changePeriods('all')}}},[_vm._v("\n                All\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.period === 'today' },attrs:{"type":"button"},on:{"click":function($event){return _vm.changePeriods('today')}}},[_vm._v("\n                Today\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.period === 'tomorrow' },attrs:{"type":"button"},on:{"click":function($event){return _vm.changePeriods('tomorrow')}}},[_vm._v("\n                Tomorrow\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.period === 'next' },attrs:{"type":"button"},on:{"click":function($event){return _vm.changePeriods('next')}}},[_vm._v("\n                Next Day\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-selectDate",class:{ 'btn-active': _vm.period === 'range' },attrs:{"type":"button"}},[_c('VueCtkDateTimePicker',{attrs:{"id":"jobBrowserDateRange","name":"jobBrowserDateRange","color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD","range":"","no-shortcuts":"","label":"Select Date","no-header":"","overlay":"","no-button-now":"","button-color":"#FFB733","no-clear-button":""},on:{"is-shown":function($event){return _vm.showPicker()},"is-hidden":function($event){return _vm.hidePicker()},"validate":function($event){return _vm.searchRange()}},model:{value:(_vm.jobBrowserDateRange),callback:function ($$v) {_vm.jobBrowserDateRange=$$v},expression:"jobBrowserDateRange"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter"},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.keyword),expression:"table.keyword"}],staticClass:"form-control",attrs:{"type":"search"},domProps:{"value":(_vm.table.keyword)},on:{"keyup":function($event){return _vm.onKeyupKeyword()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.table, "keyword", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length pull-right"},[_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.pageSize),expression:"table.pageSize"}],staticClass:"form-control v-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.table, "pageSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onChangePageSize()}]}},_vm._l((_vm.table.pageSizes),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),0),_vm._v("\n              Entries\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"table-responsive table-manage"},[_c('table',{staticClass:"table table-hover"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.table.items),function(item,index){return _c('tr',{key:index,staticClass:"detail-row"},[_c('td',{staticClass:"text-center"},[_c('strong',[(
                          _vm.isAirportTransfer(item.serviceType) &&
                          item.isPickUpAirport
                        )?_c('i',{staticClass:"ic-flight-icon"}):(
                          _vm.isAirportTransfer(item.serviceType) &&
                          item.isDropOffAirport
                        )?_c('i',{staticClass:"ic-flight-departure-icon"}):(
                          _vm.isAirportTransfer(item.serviceType) &&
                          !item.isPickUpAirport &&
                          !item.isDropOffAirport
                        )?_c('i',{staticClass:"ic-car-alt"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 1200 1200"}},[_c('path',{attrs:{"fill":"currentColor","d":"m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"}})])]):_c('i',{staticClass:"ic-time"})])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.reservationCode))]),_vm._v(" "),(!_vm.provider)?_c('span',{staticClass:"new-line"},[_vm._v("\n                      "+_vm._s(item.reservationDate.stringFullDate)+"\n                    ")]):_vm._e(),_vm._v(" "),(!_vm.provider)?_c('strong',{staticClass:"time-utc"},[_vm._v("\n                      "+_vm._s(item.reservationDate.stringHour)+":"+_vm._s(item.reservationDate.stringMinute)+"\n                      "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.reservationDate.offsetName)+")")])]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"pos-rel"},[_c('strong',[_vm._v(_vm._s(item.vehicle.className))]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                      "+_vm._s(item.vehicle.factoryName)+"\n                      "+_vm._s(item.vehicle.brandName)+"\n                    ")]),_vm._v(" "),(_vm.isAllowToRead)?_c('div',{staticClass:"row-big-menu"},[_c('ul',[(true)?_c('li',[_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.pickupJob(item)}}},[_c('span',[_vm._v("Accept Job")])])]):_vm._e(),_vm._v(" "),(_vm.isAllowToRead)?_c('li',[_c('router-link',{staticClass:"sts-warning btn btn-default",attrs:{"to":("/job/available/" + (item.reservationId)),"target":"_blank"}},[_vm._v("\n                            Details\n                          ")])],1):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('td',[(item.isTodayPickUp)?_c('span',[_c('span',{staticClass:"sts-danger"},[_vm._v("Today")]),_vm._v(",\n                      "+_vm._s(item.pickUpDate.stringDate)+"\n                      "+_vm._s(item.pickUpDate.stringShortMonth)+"\n                      "+_vm._s(item.pickUpDate.year)+"\n                    ")]):_c('span',[_vm._v(_vm._s(item.pickUpDate.stringFullDate))]),_vm._v(" "),_c('strong',{staticClass:"time-utc"},[_vm._v("\n                      "+_vm._s(item.pickUpDate.stringHour)+":"+_vm._s(item.pickUpDate.stringMinute)+"\n                      "),_c('span',{staticClass:"utc-style"},[_vm._v("\n                        ("+_vm._s(item.pickUpDate.offsetName)+")")])]),_vm._v("\n                    "+_vm._s(item.pickUpName)+"\n                  ")]),_vm._v(" "),_c('td',[(item.isTodayDropOff)?_c('span',[_c('span',{staticClass:"sts-danger"},[_vm._v("Today")]),_vm._v(",\n                      "+_vm._s(item.dropOffDate.stringDate)+"\n                      "+_vm._s(item.dropOffDate.stringShortMonth)+"\n                      "+_vm._s(item.dropOffDate.year)+"\n                    ")]):_c('span',[_vm._v(_vm._s(item.dropOffDate.stringFullDate))]),_vm._v(" "),_c('strong',{staticClass:"time-utc"},[_vm._v("\n                      "+_vm._s(item.dropOffDate.stringHour)+":"+_vm._s(item.dropOffDate.stringMinute)+"\n                      "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.dropOffDate.offsetName)+")")])]),_vm._v("\n                    "+_vm._s(item.dropOffName)+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(item.country)+"\n                  ")])])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_info --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.recordInfo))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('nav',{attrs:{"aria-label":"..."}},[_c('paginate',{attrs:{"page-count":_vm.table.totalPages,"click-handler":_vm.onNavigateCallback,"prev-text":'Previous',"next-text":'Next',"container-class":'pagination pull-right'},model:{value:(_vm.table.pageNumber),callback:function ($$v) {_vm.$set(_vm.table, "pageNumber", $$v)},expression:"table.pageNumber"}})],1)])])])]),_vm._v(" "),_c('div',{ref:"modal_subscribers",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-md"},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body mtz"},[_c('div',{staticClass:"table-modal-detail"},[_c('div',{staticClass:"table-responsive table-accordion"},[_c('table',{staticClass:"table table-hover mt-5"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.selectedJob.subscribers),function(providerName,providerId,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(providerName))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.openDispatchDialog(providerId, providerName)}}},[_c('span',[_vm._v("Dispatch")])])])])])}),0)])])])])])])])])])]),_vm._v(" "),_c('confirmModal',{attrs:{"id":'OverrideConfirmation',"header":'Potential Job Conflict',"content":"This driver has another assignment that may overlap this job. Are you sure you wish to proceed?","cancel-label":'No',"submit-label":'Yes',"color":'confirm-icon',"icon":'ic-warning'},on:{"onCancel":function($event){return _vm.cancelConfirmation()},"submit":function($event){return _vm.dispatchJob(true, true)}}}),_vm._v(" "),_c('confirmModal',{attrs:{"id":'DispatchConfirmation',"header":'Dispatch',"content":("Are you sure you want dispatch to<br/><strong>" + (_vm.selectedProvider.providerName) + "</strong>?"),"cancel-label":'Cancel',"submit-label":'Yes, Dispatch',"color":'confirm-icon',"icon":'ic-check'},on:{"submit":function($event){return _vm.dispatchJob(true)}}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-legend"},[_c('ul',[_c('li',[_c('i',{staticClass:"ic-flight-icon"}),_vm._v("Airport Transfer")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"ic-time"}),_vm._v("Hourly Booking")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Code")]),_vm._v(" "),_c('th',[_vm._v("Vehicle")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"130px"}},[_vm._v("Pick-Up")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Drop-Off")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Country")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Provider Dispatch")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"number"},[_vm._v("No")]),_vm._v(" "),_c('th',[_vm._v("Provider")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/57.14699fea613d7bd1e7cc.js